/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./index.scss";

import { duration } from "utils";
// animation
import { Fade } from "react-reveal";

// images
// import Logo from "../../../assets/icons/ft-logo.svg";
// import TwitterIcon from "../../../assets/icons/twitter.svg";
// import LinkedinIcon from "../../../assets/icons/linkedin.svg";
// import TelegramIcon from "../../../assets/icons/telegram.svg";
// import RedditIcon from "../../../assets/icons/reddit.svg";

import PrivacyNoticePDF from 'assets/docs/Privacy_policy.pdf'
import CookiePolicyPDF from 'assets/docs/Cookie_policy.pdf'
import TermConditionPDF from 'assets/docs/Terms_and_conditions.pdf'

import { Breadcrumb } from "antd";

const Footer = (props) => {
  return (
    <div className="footer">
      <div className="content customContainer">
        <Fade bottom duration={duration}>
          <Breadcrumb>
            <Breadcrumb.Item href={PrivacyNoticePDF} target='_blank'>Privacy Notice </Breadcrumb.Item>
            <Breadcrumb.Item href={CookiePolicyPDF} target='_blank'>Cookie Policy</Breadcrumb.Item>
            <Breadcrumb.Item href={TermConditionPDF} target='_blank'>Terms of Service</Breadcrumb.Item>
          </Breadcrumb>
        </Fade>

        <Fade bottom duration={duration}>
          <p>Precog © 2021 / All Rights Reserved.</p>
        </Fade>
      </div>

      {/* <div className="footerTop">
        <div className="footerTopContent">
          <Fade bottom duration={100}>
            <a href="/" className="logo">
              <img src={Logo} alt="" />
            </a>
          </Fade>

          <Fade bottom duration={100}>
            <div className="ftMenu"></div>
          </Fade>

          <Fade bottom duration={100}>
            <div className="ftSocials">
              <a
                href="https://twitter.com/precog_eth"
                target="_blank"
                rel="noreferrer"
              >
                <img src={TwitterIcon} alt="" />
              </a>{" "}
              <a
                href="https://www.linkedin.com/company/pre-cog/about/?viewAsMember=true"
                target="_blank"
                rel="noreferrer"
              >
                <img src={LinkedinIcon} alt="" />
              </a>
              <a href="https://t.me/PRE_COG" target="_blank" rel="noreferrer">
                <img src={TelegramIcon} alt="" />
              </a>
              <a
                href="https://github.com/Pre-Cog"
                target="_blank"
                rel="noreferrer"
              >
                <img src={RedditIcon} alt="" />
              </a>
            </div>
          </Fade>
        </div>
      </div>
      <div className="footerBot">
        <Fade bottom duration={100}>
          <p>Precog © 2021 / All Rights Reserved.</p>
        </Fade>
      </div> */}
    </div>
  );
};

export default Footer;
